import Linklist from '../index';

export default [
  {
    component: Linklist,
    exact: true,
    layout: 'public',
    path: '/',
  },
];
